import React, { forwardRef, useContext } from 'react';
import { useFormContext } from 'react-hook-form';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import FormControl from 'react-bootstrap/FormControl';
import FormLabel from 'react-bootstrap/FormLabel';

import { NCRContext } from 'views';

import { get, set } from 'lodash';

const InputLabel = forwardRef(
  (
    {
      callBackFunction,
      error,
      value,
      label,
      number,
      min,
      max,
      step,
      name,
      className,
      disabled,
      placeholder,
    },
    ref
  ) => {
    const { state, setState } = useContext(NCRContext);
    const { errors } = useFormContext();

    const defaultValue = get(state, name) || '';
    const defaultError = get(errors, name);
    const defaultCallback = (value) => {
      value = number ? parseFloat(value) : value;
      setState((state) => ({ ...set(state, name, value) }));
    };

    const err = error || defaultError;
    const callback = callBackFunction || defaultCallback;

    const onInput = (event) => {
      let value = event.target.value;

      // Prevent non-numeric input entirely
      if (number && value !== '') {
        value = parseFloat(value);

        if (min && value < min) {
          value = min;
        } else if (max && value > max) {
          value = max;
        }

        // Set back the value to the input element if it was adjusted
        event.target.value = value;
      }

      callback(value);
    };

    const valueProp = disabled
      ? { value: value || defaultValue }
      : { defaultValue: value || defaultValue };

    return (
      <>
        <Row className={'mb-2'}>
          <Col className={'my-auto'}>
            <FormLabel className={'w-100 my-auto'}>{`${label}:`}</FormLabel>
          </Col>
          <Col>
            <FormControl
              name={name}
              type={number ? 'number' : 'string'}
              min={min}
              max={max}
              step={step}
              ref={ref}
              {...valueProp}
              onInput={onInput}
              placeholder={placeholder}
              disabled={disabled}
              className={
                (err ? 'error ' : '') +
                (disabled ? 'read-only ' : 'general-input ') +
                (className ? className : '')
              }
            />
          </Col>
        </Row>
      </>
    );
  }
);

export { InputLabel };
